export const formModel = [
    {
        name: 'firstName',
        elementType: 'string',
        placeholder: 'First name',
        maxLength: 255
    },
    {
        name: 'lastName',
        elementType: 'string',
        placeholder: 'Last name',
        maxLength: 255
    },
    {
        name: 'dateOfBirth',
        elementType: 'date',
        placeholder: 'Date of birth',
    },
    {
        name: 'postalAddress',
        elementType: 'address',
        placeholder: 'GBR',
        label: 'Your address'
    },
    {
        name: 'phoneNumber',
        elementType: 'string',
        placeholder: 'Phone number',
        validationRegex: "^(?:\\+44|0)[1-9]\\d{9}$",
    },
    {
        name: 'email',
        elementType: 'string',
        placeholder: 'Email address',
        maxLength: 255,
        validationRegex: '(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))',

    },
]
